import { c as _c } from "react/compiler-runtime";
import { FieldController } from '@module/mdrt-org/shared/components/field-controller/field-controller';
import { MAX_CITY_LENGTH, MAX_FIRST_NAME_LENGTH, MAX_LAST_NAME_LENGTH, MAX_MIDDLE_NAME_LENGTH, STATE_PROVINCE_LENGTH } from '@module/mdrt-org/shared/utils/constants/inputs-constants';
import { PressReleasePdfType } from '@module/mdrt-org/shared/utils/enums/press-release-pdf-type';
import { LATIN_ONLY_NAME_REGEXP } from '@module/mdrt-org/shared/utils/types/regexp';
import { FormInput } from '@shared/ui-components/form-input/form-input';
import styles from '@module/mdrt-org/dashboard/dashboard-page-content/components/pdf-modal-wrapper/press-release-pdf-modal/press-release-pdf-modal.module.scss';
type PersonalInformationSectionProps = {
  cmsContent: {
    city: string;
    designation: string;
    firstName: string;
    lastName: string;
    latinOnlyMessage: string;
    middleName: string;
    personalInformationSectionTitle: string;
    requiredLabel: string;
    stateProvince: string;
  };
  containerClass: string;
  modalType: PressReleasePdfType;
  setActiveField: (field: string) => void;
};
export const PersonalInformationSection = t0 => {
  const $ = _c(46);
  const {
    cmsContent,
    containerClass,
    modalType,
    setActiveField
  } = t0;
  const t1 = styles[`${containerClass}__personal-information-block`];
  let t2;
  if ($[0] !== cmsContent.personalInformationSectionTitle) {
    t2 = <h2 className={styles["section-title"]}>{cmsContent.personalInformationSectionTitle}</h2>;
    $[0] = cmsContent.personalInformationSectionTitle;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = styles[`${containerClass}__personal-information-block-inputs`];
  const t4 = `${cmsContent.latinOnlyMessage}`;
  let t5;
  if ($[2] !== t4) {
    t5 = {
      pattern: {
        message: t4,
        value: LATIN_ONLY_NAME_REGEXP
      }
    };
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== setActiveField) {
    t6 = <FormInput className={styles["form-input"]} onFocus={() => setActiveField("FirstName")} />;
    $[4] = setActiveField;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== cmsContent.firstName || $[7] !== t5 || $[8] !== t6) {
    t7 = <FieldController label={cmsContent.firstName} maxLength={MAX_FIRST_NAME_LENGTH} name="firstName" rules={t5}>{t6}</FieldController>;
    $[6] = cmsContent.firstName;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `${cmsContent.latinOnlyMessage}`;
  let t9;
  if ($[10] !== t8) {
    t9 = {
      pattern: {
        message: t8,
        value: LATIN_ONLY_NAME_REGEXP
      }
    };
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== setActiveField) {
    t10 = <FormInput className={styles["form-input"]} onFocus={() => setActiveField("MiddleName")} />;
    $[12] = setActiveField;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== cmsContent.middleName || $[15] !== t10 || $[16] !== t9) {
    t11 = <FieldController label={cmsContent.middleName} maxLength={MAX_MIDDLE_NAME_LENGTH} name="middleName" rules={t9}>{t10}</FieldController>;
    $[14] = cmsContent.middleName;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = `${cmsContent.latinOnlyMessage}`;
  let t13;
  if ($[18] !== t12) {
    t13 = {
      message: t12,
      value: LATIN_ONLY_NAME_REGEXP
    };
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== cmsContent.requiredLabel || $[21] !== t13) {
    t14 = {
      pattern: t13,
      required: cmsContent.requiredLabel
    };
    $[20] = cmsContent.requiredLabel;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== setActiveField) {
    t15 = <FormInput className={styles["form-input"]} onFocus={() => setActiveField("LastName")} />;
    $[23] = setActiveField;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== cmsContent.lastName || $[26] !== t14 || $[27] !== t15) {
    t16 = <FieldController label={cmsContent.lastName} maxLength={MAX_LAST_NAME_LENGTH} name="lastName" rules={t14}>{t15}</FieldController>;
    $[25] = cmsContent.lastName;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== cmsContent.city || $[30] !== cmsContent.latinOnlyMessage || $[31] !== cmsContent.requiredLabel || $[32] !== cmsContent.stateProvince || $[33] !== modalType || $[34] !== setActiveField) {
    t17 = modalType !== PressReleasePdfType.MDRTFoundationGrant && <><FieldController label={cmsContent.city} maxLength={MAX_CITY_LENGTH} name="city" rules={{
        pattern: {
          message: `${cmsContent.latinOnlyMessage}`,
          value: LATIN_ONLY_NAME_REGEXP
        },
        required: cmsContent.requiredLabel
      }}><FormInput className={styles["form-input"]} onFocus={() => setActiveField("CityAndStateProvince")} /></FieldController><FieldController label={cmsContent.stateProvince} maxLength={STATE_PROVINCE_LENGTH} name="stateProvince" rules={{
        pattern: {
          message: `${cmsContent.latinOnlyMessage}`,
          value: LATIN_ONLY_NAME_REGEXP
        }
      }}><FormInput className={styles["form-input"]} onFocus={() => setActiveField("CityAndStateProvince")} /></FieldController></>;
    $[29] = cmsContent.city;
    $[30] = cmsContent.latinOnlyMessage;
    $[31] = cmsContent.requiredLabel;
    $[32] = cmsContent.stateProvince;
    $[33] = modalType;
    $[34] = setActiveField;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t11 || $[37] !== t16 || $[38] !== t17 || $[39] !== t3 || $[40] !== t7) {
    t18 = <div className={t3}>{t7}{t11}{t16}{t17}</div>;
    $[36] = t11;
    $[37] = t16;
    $[38] = t17;
    $[39] = t3;
    $[40] = t7;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t1 || $[43] !== t18 || $[44] !== t2) {
    t19 = <section className={t1}>{t2}{t18}</section>;
    $[42] = t1;
    $[43] = t18;
    $[44] = t2;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
};